import { TApplicationState } from '../../types/redux';

export const getIsCompareFlightModalOpen = (state: TApplicationState) =>
  state.compareFlightTooltip.isCompareFlightModalOpen;
